import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login as loginService } from '../services/authService';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await loginService(email, password);
      console.log(data);
      login(data.user, data.token);
      navigate('/');
    } catch (err) {
      const msg = err.response?.data?.msg || 'Credenciales incorrectas. Intente de nuevo.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo">O</div>

        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h4 style={{
            fontFamily: 'var(--orig-font-display)',
            fontWeight: 800,
            fontSize: 22,
            color: 'var(--orig-text)',
            letterSpacing: 1,
            marginBottom: 6,
          }}>
            ORÍGENES
          </h4>
          <p style={{ fontSize: 13, color: 'var(--orig-text-muted)' }}>
            Sistema de Control de Inventario
          </p>
        </div>

        {error && (
          <div className="alert-orig alert-error" style={{ marginBottom: 20 }}>
            <i className="bi bi-exclamation-circle-fill" />
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} autoComplete="on">
          <div style={{ marginBottom: 18 }}>
            <label className="form-label">Correo electrónico -</label>
            <div style={{ position: 'relative' }}>
              <i className="bi bi-envelope" style={{
                position: 'absolute', left: 13, top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--orig-text-muted)', fontSize: 15, pointerEvents: 'none',
              }} />
              <input
                type="email"
                className="form-control"
                placeholder="correo@ejemplo.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                style={{ paddingLeft: 38 }}
                required
                autoComplete="email"
              />
            </div>
          </div>

          <div style={{ marginBottom: 28 }}>
            <label className="form-label">Contraseña -</label>
            <div style={{ position: 'relative' }}>
              <i className="bi bi-lock" style={{
                position: 'absolute', left: 13, top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--orig-text-muted)', fontSize: 15, pointerEvents: 'none',
              }} />
              <input
                type={showPass ? 'text' : 'password'}
                className="form-control"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                style={{ paddingLeft: 38, paddingRight: 42 }}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPass(v => !v)}
                style={{
                  position: 'absolute', right: 12, top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none', border: 'none',
                  color: 'var(--orig-text-muted)', cursor: 'pointer',
                  padding: '2px 4px', fontSize: 15,
                }}
                tabIndex={-1}
              >
                <i className={`bi ${showPass ? 'bi-eye-slash' : 'bi-eye'}`} />
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn-orig btn-orig-green login-btn-full"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="login-spinner" />
                Iniciando sesión...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right" />
                Iniciar Sesión
              </>
            )}
          </button>
        </form>

        <div style={{
          marginTop: 28,
          paddingTop: 18,
          borderTop: '1px solid var(--orig-border)',
          textAlign: 'center',
          fontSize: 11,
          color: 'var(--orig-text-hint)',
        }}>
          <i className="bi bi-shield-check" style={{ marginRight: 5, color: 'var(--orig-green)' }} />
          Conexión segura — Orígenes v1.0.0
        </div>
      </div>
    </div>
  );
}
